import { atom } from 'jotai';

import type { Props as BreadcrumbItem } from 'src/containers/Breadcrumbs/BreadcrumbsItem';

export const breadcrumbsAtom = atom<BreadcrumbItem[]>([]);
